import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustMonitorCards: "DustMonitorCard.DustMonitorCards",
  list: "DustMonitorCard.DustMonitorCardList",
  updateVee: "DustMonitorCard.VeeUpdate",
};

export { names as dustMonitorCardRouteNames };

const dustMonitorCardRoutes: RouterOptions["routes"] = [
  {
    path: "/dustMonitorCard",
    name: names.dustMonitorCards,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Monitor Cards",
          lookupGroups: [],
        },
        component: () => import("@/views/dustMonitorCard/DustMonitorCardList.vue"),
      },
      {
        path: "update-vee",
        component: () => import("@/views/dustMonitorCard/VeeBase.vue"),
        redirect: { name: names.updateVee },
        children: [
          {
            path: "",
            name: names.updateVee,
            meta: { title: "Update VEE", isForm: true },
            component: () => import("@/views/dustMonitorCard/VeeUpdate.vue"),
          },
        ],
      },
    ],
  },
];
export default dustMonitorCardRoutes;
